var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-header-index-wide" }, [
    _c("div", { staticClass: "outBox" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "l-before" }, [_vm._v("修 复 前")]),
        _c(
          "div",
          { staticClass: "firstPic" },
          [
            _c("j-image-upload", {
              attrs: { text: "上传需要修复的人脸照片" },
              on: { change: _vm.change },
              model: {
                value: _vm.picUrl,
                callback: function ($$v) {
                  _vm.picUrl = $$v
                },
                expression: "picUrl",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "firstPic" },
          [
            _c("j-image-upload", {
              attrs: { text: "上传帮助修复的清晰人脸照片" },
              model: {
                value: _vm.picUrl1,
                callback: function ($$v) {
                  _vm.picUrl1 = $$v
                },
                expression: "picUrl1",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "middle" }, [
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "m-img",
          attrs: { src: require("@/assets/aver.gif"), alt: "" },
        }),
        _c("div", { staticClass: "b-tran", on: { click: _vm.startXf } }, [
          _vm._v(" " + _vm._s(_vm.visible ? "正在修复" : "开始修复")),
        ]),
      ]),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "l-after" }, [_vm._v("修 复 后")]),
        _c("div", { staticClass: "r-firstPic" }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.rightPicUrl,
                expression: "rightPicUrl",
              },
            ],
            staticClass: "r-img",
            attrs: {
              src:
                _vm.window._CONFIG["resourceURL"] +
                "/school/sys/common/downloadSlice?filename=" +
                _vm.rightPicUrl,
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }